<template>
  <div class="webchat-route-root">
    <div class="webchat-route">
      <react-wrapper :component="webChat" :onGoToSummary="goToSummary" />
    </div>
    <EventLogic />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import EventLogic from '../../events/EventLogic.vue'
import { WebChat } from '@/react-components/components/web-chat'

@Component({
  components: {
    EventLogic,
  },
})
export default class WebChatRoute extends Vue {
  get webChat() {
    return WebChat
  }

  public goToSummary() {
    this.$router.push('/summary')
  }
}
</script>

<style>
.webchat-route-root,
.webchat-route {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
